import React, { useState } from 'react'
import { AllCategoryLayoutComponent } from '../Components/Category/AllCategoryLayoutComponent';
import { AllPriceComponent } from '../Components/Price/AllPriceComponent';
import { EditPriceComponent } from '../Components/Price/EditPriceComponent';
import { AddPriceComponent } from '../Components/Price/AddPriceComponent';
import { PriceCategoryComponent } from '../Components/Category/PriceCategoryComponent';
// ======================================================================
export const Price = ({ setLoading, showMessage }) => {
    // ======================================================================
    const [view, setView] = useState('Category');
    const [categoryId, setCategoryId] = useState();
    const [categoryTitle, setCategoryTitle] = useState();
    const [version, setVersion] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [priceId, setPriceId] = useState();
    // ======================================================================
    return (
        <>
            {view === "Category" ?
                <PriceCategoryComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    onClickItems={(id, title) => { setCategoryId(id); setCategoryTitle(title); setView("All"); }}
                />
                : <></>
            }
            {view === "All" ?
                <>
                    <AllPriceComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        categoryId={categoryId}
                        categoryTitle={categoryTitle}
                        version={version}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        onAddClick={() => setView("Add")}
                        onBackClick={() => setView("Category")}
                        onEdit={(priceId) => { setPriceId(priceId); setView("Edit") }}
                        onRowDeleted={() => { setVersion(version + 1); setView("All"); }}
                    />
                </> : <></>
            }
            {view === "Edit" ?
                <EditPriceComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    rowUpdated={() => { setVersion(version + 1); setView("All"); }}
                    cancelEdit={() => { setView("All") }}
                    id={priceId}
                /> : <></>
            }
            {view === "Add" ?
                <AddPriceComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    categoryId={categoryId}
                    rowInserted={() => { setVersion(version + 1); setView("All") }}
                    cancelInsert={() => setView("All")}
                /> : <></>
            }
        </>
    )
}
